export default __webpack_public_path__ + "static/media/webView.eaed8975.png";